import React from 'react';
import {
  MainButton,
  StyledModal,
  StyledModalHeader,
  SubmitButton,
} from '../../../../common/form/FormElements';
import Form from '../../../../antd/form/Form/Form';
import { Form as AntdForm, Grid, Alert } from 'antd';
import FormFileUpload from '../../../../antd/form/FormFileUpload/FormFileUpload';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { required } from '../../../../antd/form/FormValidation';

const ErrorMessages = ({ errors }) => {
  const { t } = useTranslation();

  if (!Array.isArray(errors) || errors.length === 0) return null;

  return (
    <div style={{ marginTop: 16 }}>
      <Alert
        type="error"
        showIcon
        message={t('Importovaný súbor obsahuje jednu alebo viacero chýb:')}
        description={
          <ul style={{ paddingLeft: 20, margin: 0 }}>
            {errors.map((message, idx) => (
              <li key={`err-${idx}`}>{message}</li>
            ))}
          </ul>
        }
      />
    </div>
  );
};

ErrorMessages.propTypes = {
  errors: PropTypes.array,
};

const AcceptedStudentsImport = ({ toggle, onSubmit, validationErrors }) => {
  const { t } = useTranslation();
  const [form] = AntdForm.useForm();
  const screens = Grid.useBreakpoint();

  const [showWarning, setShowWarning] = React.useState(false);
  const [hideErrors, setHideErrors] = React.useState(false);

  const watchedFile = AntdForm.useWatch('file', form);
  React.useEffect(() => {
    if (watchedFile) {
      setShowWarning(true);
      setHideErrors(true);
    }
  }, [watchedFile]);

  React.useEffect(() => {
    if (Array.isArray(validationErrors) && validationErrors.length > 0) {
      setShowWarning(false);
      setHideErrors(false);
    }
  }, [validationErrors]);

  const initials = { file: undefined };

  return (
    <StyledModal
      open
      onCancel={() => toggle()}
      footer={null}
      width={screens.md ? '60%' : '100%'}
    >
      <StyledModalHeader>{t('Import prijatých študentov')}</StyledModalHeader>
      <Form onFinish={onSubmit} initialValues={initials} form={form}>
        {() => (
          <div style={{ padding: '10px' }}>
            <Alert
              type="info"
              showIcon
              message={t('Čo sa vykoná pri importe')}
              description={
                <ul style={{ paddingLeft: 20, margin: 0 }}>
                  <li>{t('Import sa vykonáva pre aktuálny akademický rok nastavený v module.')}</li>
                  <li>{t('Pred importom sa vymažú všetky doterajšie záznamy prijatých študentov pre tento rok.')}</li>
                  <li>{t('Login musí existovať v databáze a musí patriť aktívnemu študentovi.')}</li>
                  <li>{t('Zameranie sa mapuje na študijný program podľa stĺpca code_in_st_group v tabuľke study_programs.')}</li>
                  <li>{t('Ak sa nájde chyba v ľubovoľnom riadku, celý import sa zruší a neuloží sa nič.')}</li>
                  <li>{t('Po úspešnom importe sa naimportovaným študentom automaticky uzamkne priraďovanie projektov.')}</li>
                </ul>
              }
              style={{ marginBottom: 16 }}
            />

            <h4>{t('Formát importovaného súboru:')}</h4>
            <ul>
              <li>
                {t('Pri ukladaní súboru v MS Excel je potrebné vybrať typ:')}{' '}
                <strong>{t('CSV UTF-8 (oddelené čiarkami)')}</strong>
              </li>
              <li>
                {t('Importovaný súbor nesmie mať záhlavie')}
              </li>
              <li>
                {t('Riadok sa skladá z nasledovných stĺpcov:')}{' '}
                <strong>{t('Login, Zameranie, Priemer')}</strong>
              </li>
              <li>{t('Povinné stĺpce sú: Login a Zameranie')}</li>
              <li>{t('Ak chýba stĺpec Priemer, automaticky sa doplní hodnota 5.')}</li>
              <li>
                {t(
                  'Oddeľovač stĺpcov je bodkočiarka, oddeľovač riadkov je nový riadok',
                )}
              </li>
              <li>
                {t(
                  'Zameranie zodpovedá 4. písmenu v označení št. skupín',
                )}
              </li>
            </ul>
            <h4 style={{ marginTop: '20px' }}>
              {t('Príklad jedného riadku v importovanom súbore:')}
            </h4>
            <p>
              <em>novak01;A;1.96</em>
            </p>
            <FormFileUpload
              label={t('Vybrať súbor')}
              name={'file'}
              rules={[required(t)]}
            />

            {showWarning && (
              <Alert
                type="warning"
                showIcon
                message={t(
                  'V prípade, že sa v importovanom súbore nachádzajú chyby, záznamy nebudú uložené.',
                )}
              />
            )}

            {!hideErrors && <ErrorMessages errors={validationErrors} />}

            <FormButtonsContainer>
              <MainButton onClick={() => toggle()}>{t('Zrušiť')}</MainButton>
              <SubmitButton
                submitKey={'file'}
                onClick={() => setShowWarning(true)}
              >
                {t('Nahrať')}
              </SubmitButton>
            </FormButtonsContainer>
          </div>
        )}
      </Form>
    </StyledModal>
  );
};

AcceptedStudentsImport.propTypes = {
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
  validationErrors: PropTypes.any,
};

export default AcceptedStudentsImport;
